import { Invoice } from "../RTK/userApi";

export interface FavoriteItem {
  productId: string;
  platformGroupId: string;
}

// Normalized provider identity subdocument (server-aligned)
export interface ProviderIdentity {
  provider: string;                 // e.g. 'google','discord','microsoft','steam','epic','twitch','x','kick','apple'
  providerUserId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  linkedAt?: string;                // ISO datetime
  scopes?: string[];
  metadata?: Record<string, unknown>;
}

export interface User {
  email: string;
  _id: string;
  firstName: string;
  lastName: string;
  birthday: string;
  address: string;
  city: string;
  zip: string;
  country: string;
  favorites: FavoriteItem[];
  invoices: Invoice[];
  // Normalized provider identities (required)
  providers: ProviderIdentity[];
  phoneNumber?: string;
  phone?: string;
  referralCode?: string | null;
  ref?: string | null;
  referrerId?: string | null;
  referralCount?: number;
  referralTarget?: number | null;
  referralBalances?: Record<string, number> | null;
  referralTotals?: Record<string, number> | null;
  referralDisplayCurrency?: string | null;
  referralDisplayTotal?: number | null;
  referrals?: string[];
}

interface AuthState {
  user: User | null;
  token: string | undefined;
  isLoggedIn: boolean;
  welcomePageLoading: boolean;
  isLoading: boolean;
  hasMissingInfo: boolean;
  isEmailVerified: boolean;
  identityRequireCheck: boolean;
  isSocialLoginLoading: boolean;
  verificationSecret: string | null;
  verificationError: string | null;
  verificationStatus: string;
  mainLayoutFade: boolean;
  activePurchase: boolean;
  error: string | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  language: string;
  filter: {
    platform: string;
    maxPrice: string;
    category: string;
    type: string;
    genre: string;
    sort: string;
  };
  selectedCurrency: string;
  selectedCurrencySymbol: string;
  selectedRegion: string;
  userIp: string | null;
  isOnline: boolean;
  pendingReferralCode: string | null;
}

export const initialState: AuthState = {
  user: null,
  token: undefined,
  isLoggedIn: false,
  welcomePageLoading: false,
  isSocialLoginLoading: false,
  isLoading: false,
  isEmailVerified: false,
  hasMissingInfo: true,
  identityRequireCheck: false,
  verificationSecret: null,
  verificationError: null,
  verificationStatus: "processing_verification",
  mainLayoutFade: false,
  activePurchase: false,
  error: null,
  status: "idle",
  language: "en",
  filter: {
    platform: "",
    maxPrice: "",
    category: "",
    type: "",
    genre: "",
    sort: "A-Z",
  },
  selectedCurrency: "EUR",
  selectedCurrencySymbol: "€",
  selectedRegion: "EU",
  userIp: null,
  isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
  pendingReferralCode: null,
};
